
export default {
  getCompetitionImagePath(path) {
    if (!path || path === null || path.length === 0) {
      path = '/images/iconfinder_gallery_2199104.png';
    } else {
      path = '/uploads/images/' + path;
    }
    return path;
  },
  getUserImagePath(path) {
    if (!path || path === null || path.length === 0) {
      path = '/images/anonym.png';
    } else {
      path = '/uploads/images/' + path;
    }
    return path;
  },
  getProjectImagePath(path) {
    if (!path || path === null || path.length === 0) {
      path = '/images/default_project.png';
    } else {
      path = '/uploads/images/' + path;
    }
    return path;
  }
}